import addGridCapabilities from 'toxilibs/grid.js'
import Cell from './cell.js'

function GameMap (params) {

    let {eventBus, colorMap, startPosition, transform} = params

    let height = colorMap.length


    addGridCapabilities(this, {
        width: colorMap[0].length,
        height,
        content: (x, y) => {
            return {
                color: colorMap[height - y - 1][x]
            }
        },
        toric: params.toric
    })

    this.getCell(startPosition.x, height - 1 - startPosition.y).player = true

    if (transform) {
        transform(this)
    }

    this.setCells((x, y) => {
        let {color, player} = this.getCell(x, y)
        if (player) {
            this.startPosition = {x, y}
        }
        return new Cell(eventBus, {x, y, color})
    })

    this.reset = function () {
        this.forEachCell(cell => cell.reset())
    }

    eventBus.emit('map loaded', this)

}


GameMap.prototype.neighbourCellFor = function (cell, vector) {
    return this.getCell(
        cell.x + vector.x,
        cell.y + vector.y
    )
}


GameMap.prototype.isNeighbour = function (cell, otherCell) {
    return this.neighboursOf(cell.x, cell.y).includes(otherCell)
}


GameMap.prototype.neighbourVectorDirection = function (cell, {x, y}) {
    const otherCell   = this.getCell(x, y)
    const isNeighbour = this.isNeighbour(cell, otherCell)

    if (!isNeighbour) {
        return false
    }


    let vectorDirection = {
        x: otherCell.x - cell.x,
        y: otherCell.y - cell.y
    }

    if (Math.abs(vectorDirection.x) + Math.abs(vectorDirection.y) > 1) {
        vectorDirection = {
            x: -Math.sign(vectorDirection.x),
            y: -Math.sign(vectorDirection.y)
        }
    }

    return vectorDirection
}



export default GameMap

